import { render } from "./ServiceCategoriesTable.vue?vue&type=template&id=064b45dd&scoped=true"
import script from "./ServiceCategoriesTable.vue?vue&type=script&lang=js"
export * from "./ServiceCategoriesTable.vue?vue&type=script&lang=js"

import "./ServiceCategoriesTable.vue?vue&type=style&index=0&id=064b45dd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064b45dd"]])

export default __exports__